module.exports = __webpack_public_path__ + "static/media/udemy-mobile.d8ee1566.png";